import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Casino from '@swf/core/assets/casino.svg';
import FoxBet from '@swf/core/assets/fox-bet.svg';
import FoxBetCasino from '@swf/core/assets/foxbet-casino.svg';
import FoxBetPoker from '@swf/core/assets/foxbet-poker.svg';
import FullTiltCasino from '@swf/core/assets/fulltilt-casino.svg';
import FullTiltPoker from '@swf/core/assets/fulltilt-poker.svg';
import PokerDesh from '@swf/core/assets/poker-desh.svg';
import Poker from '@swf/core/assets/poker.svg';
import PokerStarsCasino from '@swf/core/assets/pokerstars-casino.svg';
import PokerStars from '@swf/core/assets/pokerstars-icon.svg';
import Sports from '@swf/core/assets/sports.svg';
import VegasDesh from '@swf/core/assets/vegas-desh.svg';
import Vegas from '@swf/core/assets/vegas.svg';
import { select } from '@swf/core/store';

import { Vertical } from '../BrandLinks';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../BrandLinks.scss';
import LocalizedIcon from '../LocalizedIcon/LocalizedIcon';

const icons = {
  Casino,
  FoxBet,
  FoxBetCasino,
  FoxBetPoker,
  FullTiltCasino,
  FullTiltPoker,
  Poker,
  PokerDesh,
  PokerStars,
  PokerStarsCasino,
  Sports,
  Vegas,
  VegasDesh
};

export interface Props {
  active?: boolean;
  icon: keyof typeof Vertical;
}

const Icon: React.FC<Props> = ({ active, icon }) => {
  const isSiteUS = useSelector(select.cms.isSiteUS);

  if (['Poker', 'Casino', 'Sports'].includes(icon)) {
    return <LocalizedIcon vertical={Vertical[icon]} active={active} />;
  }

  return React.createElement(icons[icon], {
    className: classNames(styles.icon, styles[camelCase(icon) as keyof typeof styles], {
      [styles.active]: active,
      [styles.usMultibrandIcon]: isSiteUS
    })
  });
};

export default Icon;
